module.exports = __webpack_public_path__ + "media/images/fb_web-bb0c3982dd3839b6686b4d654e1f755b.svg";